import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Link } from 'react-router-dom';
import { Tooltip, Paper, Grid } from '@material-ui/core';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateLead from "./CreateLead";
import Moment from "moment";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";


const todate = new Date();
// var fromdate = todate.getFullYear() + '/04/01';
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), 1);


const Lead = () => {
  const [LeadNo, setLeadNo] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [LeadID, setLeadID] = useState('');
  const [Count, setCount] = useState();
  const [LeadStatus, setLeadStatus] = useState('');
  const [CompanyName, setCompanyName] = useState('');
  const [FromDate, setFromDate] = useState(fromdate.toISOString());
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [response, fetchData] = UseFetchData();

  const handleOpenModal = () => {
    setLeadID('');
    setOpen(true);
  };

  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("UserID", sessionStorage.UID);
    bodyFormData.append("UserType", sessionStorage.UserType);
    bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
    bodyFormData.append("LeadNo", LeadNo);
    bodyFormData.append("LeadStatus", LeadStatus);
    bodyFormData.append("CompanyName", CompanyName);
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    fetchData("Lead/List", bodyFormData);
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "LeadNo",
        headerName: "Lead No",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "LeadDate",
        headerName: "Lead Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "ContactName",
        headerName: "Contact Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "Designation",
        headerName: "Designation",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "Department",
        headerName: "Department",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "CompanyName",
        headerName: "Company Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "Phone",
        headerName: "Phone",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Mobile",
        headerName: "Mobile",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Email",
        headerName: "Email",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
        renderCell: (params) => (
          <Tooltip title={params.row.Email} >
            <span className="table-cell-trucate">{params.row.Email}</span>
          </Tooltip>
        ),
      },
      {
        field: "Address1",
        headerName: "Address 1",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.Address1} >
            <span className="table-cell-trucate">{params.row.Address1}</span>
          </Tooltip>
        ),
      },
      {
        field: "Address2",
        headerName: "Address 2",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.Address2} >
            <span className="table-cell-trucate">{params.row.Address2}</span>
          </Tooltip>
        ),
      },
      {
        field: "City",
        headerName: "City",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "State",
        headerName: "State",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "PINCode",
        headerName: "PIN Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "CreatedBy",
        headerName: "Created By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "ModifiedBy",
        headerName: "Modified By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]
  );

  useEffect(() => {
    PopulateData();
  }, [])

  function CustomToolbar() {
    return (
        <GridToolbarContainer style={{ marginLeft: '93%' }}>
            <GridToolbarExport csvOptions={{
                fields: ['LeadNo', 'LeadDate', 'ContactName', 'Designation', 'Department', 'CompanyName', 'Phone', 'Mobile', 'Email', 'Address1', 'Address2', 'City','State','PINCode','CreatedBy','ModifiedBy']
            }} />
        </GridToolbarContainer>
    );
}

  /* if (viewPath) return (
    <Redirect to={{ pathname: viewPath, state: { AccountID: AccountID }  }} />
  ); */

  return (
    <div >
      <Grid container direction="row" style={{ marginTop: -10 }} >
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Input
            label="Lead No"
            id="LeadNo"
            style={{ width: "180px" }}
            onChange={(e) => setLeadNo(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Input
            label="Lead Status"
            id="LeadStatus"
            style={{ width: "180px" }}
            onChange={(e) => setLeadStatus(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20, paddingTop: 0, paddingBottom: 0 }}>
          <BiztranControls.Input
            label="Company Name"
            id="CompanyName"
            style={{ width: "180px" }}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" style={{ marginTop: 0 }}>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }}>
          <div style={{ width: "180px", marginLeft: 6 }}>
            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setFromDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onFromClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultfromDate}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 20 }}>
          <div style={{ width: "180px", marginLeft: 6 }}>
            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setToDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onToClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultToDate}
            />
          </div>
        </Grid>
        <Grid xs={6} md={4} sm={8} lg={4} xl={3} >
          <div style={{ width: "100%", margin: 10 }} >
            <div style={{ float: "left", marginTop: 22, width: "30%" }}>
              <BiztranControls.Button
                responsive="true"
                text="Search"
                startIcon={<SearchIcon />}
                onClick={() => {
                  PopulateData();
                }}
              />

            </div>
            <div style={{ float: "left", marginTop: 35, marginLeft: 7 }}>
              <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
            </div>
            <div style={{ float: "left", marginTop: 22, paddingLeft: 10, width: "30%" }}>
              <BiztranControls.Button
                responsive="true"
                text="ADD NEW"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                  handleOpenModal();
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>


      <BiztranControls.DataGrid
        headerHeight={34}
        rowHeight={25}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        // autoHeight={true}
        Height="400px"
        //Height="700px"
        Width="100%"
        components={{ Toolbar: CustomToolbar, }}
      />
      <ModalFrame
        title="Lead Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateLead
          LeadID={LeadID}
          setOpen={setOpen}
          PopulateData={PopulateData}
        />
      </ModalFrame>
    </div>
  );
};

export default Lead;
